import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterBy',
  standalone: false
})
@Injectable()
export class FilterByPipe implements PipeTransform {
  public transform(items: any[], key: string, value: any, _arrayLength?: number): any[] {
    return value === undefined
      ? items
      : items.filter((item) =>
          Array.isArray(item[key]) ? (item[key] as []).some((y) => y === value) : item[key] === value
        );
  }
}
